import Image from "next/image";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import React, { useState, useRef, useCallback, useEffect } from "react";
import { CalendarIcon } from "@radix-ui/react-icons";

type Alumni = {
  name: string;
  img: string;
  des: string;
  compLogo: string;
  alt: string;
  alliance: string;
  linkdin: string;
};

type JamesAlumni = {
  name: string;
  img: string;
  des: string;
  compLogo: string;
  alt: string;
  alliance: string;
  linkdin: string;
};

const DoctorResidencyMobile = () => {
  const [activeTab, setActiveTab] = useState("george");

  const autoplayRef = useRef(
    Autoplay({
      delay: 3000,
      stopOnInteraction: false,
      stopOnMouseEnter: false,
      stopOnFocusIn: false,
    }),
  );

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      slidesToScroll: 1,
      skipSnaps: false,
      dragFree: false,
      containScroll: "trimSnaps",
    },
    [autoplayRef.current],
  );

  useEffect(() => {
    if (emblaApi && autoplayRef.current) {
      autoplayRef.current.play();
    }
  }, [emblaApi]);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const big4Data: Alumni[] = [
    {
      name: "Dhruv Gupta",
      img: "/healthcare/doctors/new-mob/Dhruv-Gupta.png",
      alt: "dhruv gupta, doctor's alumni - miles education",
      des: "I’m incredibly thankful to SGU for the knowledge and skills that they have provided me that helped me attend to the situation onboard.",
      compLogo: "/healthcare/doctors/new-mob/elmhurst.png",
      alliance: "Elmhurst Hospital",
      linkdin: "https://www.linkedin.com/in/dhruvgupta20/",
    },
    {
      name: "Garima Gupta",
      img: "/healthcare/doctors/new-mob/Garima-Gupta.png",
      alt: "Garima gupta, doctor's alumni - miles education",
      des: "I can’t think of many other schools where you can study on a campus with stunning views of the ocean.",
      compLogo: "/healthcare/doctors/new-mob/oneal.png",
      alliance: "O’Neal Comprehensive Cancer Center",
      linkdin: "https://www.linkedin.com/in/garima-gupta-a76311178/",
    },
    {
      name: "Nanditha Guruvaiah",
      img: "/healthcare/doctors/new-mob/Nanditha-Guruvaiah.png",
      alt: "Nanditha, doctor's alumni - miles education",
      des: "I’m so grateful to my family and friends, and most importantly the mentors I gained through SGU for supporting me on this long but fruitful journey.",
      compLogo: "/healthcare/doctors/new-mob/wake-forest.png",
      alliance: "Wake Forest Baptist Medical Center",
      linkdin: "https://www.linkedin.com/in/nanditha-guruvaiah-md-a0213622b/",
    },
    {
      name: "Sarthak Kulshreshtha",
      img: "/healthcare/doctors/new-mob/Sarthak-Kulshreshtha.png",
      alt: "Sarthak Kulshreshtha, doctor's alumni - miles education",
      des: "I am grateful for the education and experiences that SGU has provided me and would highly recommend the university to anyone considering a medical career.",
      compLogo: "/healthcare/doctors/new-mob/illinois.png",
      alliance: "University of Illinois College of Medicine",
      linkdin: "https://www.linkedin.com/in/sarthak-kulshreshtha-b27a14123/",
    },
    {
      name: "Nandini Nair",
      img: "/healthcare/doctors/new-mob/Nandini-Nair.png",
      alt: "Nandini Nair, doctor's alumni - miles education",
      des: "Without SGU, I would not have reached where I am today, and I’ve seen several of my classmates do extremely well also.",
      compLogo: "/healthcare/doctors/new-mob/pennstate.png",
      alliance: "Penn State college of Medicine",
      linkdin:
        "https://www.linkedin.com/in/nandini-nair-md-phd-cpe-mhl-facc-fsvm-facp-fhfsa-faha-99669a43/",
    },
    {
      name: "Varshitha Tumkur Panduranga",
      img: "/healthcare/doctors/new-mob/Varshitha.png",
      alt: "Varshitha Tumkur Panduranga, doctor's alumni - miles education",
      des: "With its high match rates at US residencies and extensive hospital affiliations, SGU provided me with a convenient route to residency. ",
      compLogo: "/healthcare/doctors/new-mob/downstate.png",
      alliance: "Suny Downstate Health Sciences University",
      linkdin: "https://www.linkedin.com/in/varshitha-panduranga-668347222/",
    },
    {
      name: "Dhaval Patel",
      img: "/healthcare/doctors/new-mob/Dhaval-Patel.png",
      alt: "Dhaval Patel, doctor's alumni - miles education",
      des: "I chose to study at St. George’s University because it offers a pathway into practicing in the US and it’s one of the top schools in the Caribbean ",
      compLogo: "/healthcare/doctors/new-mob/trinity.png",
      alliance: "Trinity Health System",
      linkdin: "https://www.linkedin.com/in/dhaval-patel-8b130b18/",
    },
    {
      name: "Disha Sason",
      img: "/healthcare/doctors/new-mob/Disha-Sason.png",
      alt: "Disha Sason, doctor's alumni - miles education",
      des: "For USMLE preparation, SGU provided me with sufficient support both emotionally and academically for me to feel prepared to take these exams",
      compLogo: "/healthcare/doctors/new-mob/monte.png",
      alliance: "Montefiore Medical Center",
      linkdin: "",
    },
    {
      name: "Aadhyaa Shenoy",
      img: "/healthcare/doctors/new-mob/Aadhyaa.png",
      alt: "Aadhyaa Shenoy, doctor's alumni - miles education",
      des: "SGU gave me an organized gateway into the US to pursue residency.",
      compLogo: "/healthcare/doctors/new-mob/wright.png",
      alliance: "The Wright Center for Graduate Medical Education",
      linkdin: "https://www.linkedin.com/in/aadhyaa-shenoy/",
    },
  ];

  const jamesData: JamesAlumni[] = [
    {
      name: "Dr. Molly Jain",
      img: "/healthcare/doctors/new-mob/Molly-Jain.png",
      alt: "Dr. Molly Jain, doctor's alumni - miles education",
      des: "Start early, establish a daily routine with question banks, and connect with experienced professionals at conferences",
      compLogo: "/healthcare/doctors/new-mob/parkview.png",
      alliance: "Parkview Health",
      linkdin: "https://www.linkedin.com/in/jainmolly90/",
    },
    {
      name: "Dr. Erika Singh",
      img: "/healthcare/doctors/new-mob/Erika.png",
      alt: "Dr. Erika Singh, doctor's alumni - miles education",
      des: "SJSM will be there to support you, help you with your rotations, & make sure you have the resources you need to get that MD.",
      compLogo: "/healthcare/doctors/new-mob/medicine.png",
      alliance: "Center for Family Medicine",
      linkdin: "https://www.linkedin.com/in/erika-singh-md-0b6675b7/",
    },
    {
      name: "Dr. Ronnie Archie",
      img: "/healthcare/doctors/new-mob/Ronnie.png",
      alt: "Dr. Ronnie Archie, doctor's alumni - miles education",
      des: "My journey serves as an inspiring testament to the resilience and dedication required to excel in the field of medicine.",
      compLogo: "/healthcare/doctors/new-mob/franciscan.png",
      alliance: "Franciscan Health",
      linkdin: "",
    },
    {
      name: "Dr. Saad Hanan",
      img: "/healthcare/doctors/new-mob/Saad.png",
      alt: "Dr. Saad Hanan, doctor's alumni - miles education",
      des: "Dr. Saad Hanan is a visionary SJSM Alumni who has left an indelible mark on the field of medicine and medical education.",
      compLogo: "/healthcare/doctors/new-mob/family.png",
      alliance: "Louisiana Academy of Family Physicians",
      linkdin: "https://www.linkedin.com/in/saad-hanan-99a587130/",
    },
    {
      name: "Dr. Crystal Richardson",
      img: "/healthcare/doctors/new-mob/Crystal.png",
      alt: "Dr. Crystal Richardson, doctor's alumni - miles education",
      des: "I am currently in the process of enhancing my resume with research publications",
      compLogo: "/healthcare/doctors/new-mob/monte.png",
      alliance: "Montefiore Medical Center",
      linkdin: "https://www.linkedin.com/in/crystal-richardson-290385b9/",
    },
  ];

  return (
    <>
      <div className="mx-auto w-full px-5 md:px-6 xl:px-0 lg:!px-6 relative bg-[#061A2F] pt-7">
        <Image
          src="/cpa/visit/newVisit/nr_big.png"
          alt="Special Offer"
          className="absolute top-0 right-0 scale-x-[-1] hidden md:block"
          width={650}
          height={440}
          loading="lazy"
        />
        <Image
          src="/cpa/visit/newVisit/nr_sm.png"
          alt="Special Offer"
          className="absolute bottom-0 left-0 scale-x-[-1] md:hidden"
          width={200}
          height={240}
          loading="lazy"
        />

        <p className="text-[20px] leading-[1.3] text-center font-semibold flex justify-center items-center text-[#1772EA] mb-2">
          <CalendarIcon className="text-[#1872EA] text-[20px] w-[25px] h-[25px] mr-2" />
          Years 6-9
        </p>

        <h3 className="font-semibold text-center text-[26px] md:text-[32px] xl:text-[54px] text-white relative z-20 mb-3">
          Residency in{" "}
          <span className="inline-block visit_txt pr-[5px]">USA</span>
        </h3>

        <p className="font-medium text-[16px] md:text-[20px] text-white text-center mb-6">
          Hear from our alumni who've been placed successfully at top medical
          facilities in USA earning <br className="hidden md:block" />
          upwards of $55k/year during their residency
        </p>

        <div className="w-full flex flex-col justify-center items-center pb-[30px] relative z-20">
          {/* Tabs */}
          <div className="flex justify-center bg-[#000] mt-2 w-full max-w-[100%] rounded-[36px] p-1 mb-6">
            <button
              className={`font-semibold text-[14px] md:text-[18px] flex justify-center gap-2 items-center w-1/2 px-3 py-2 text-center rounded-full ${
                activeTab === "george"
                  ? "bg-[#061a2f] shadow-[inset_0_0_18px_0_rgba(255,186,8,0.24)] text-white"
                  : "text-white brightness-[0.5]"
              }`}
              onClick={() => setActiveTab("george")}
            >
              <span className="text-left leading-[1.2]">
                St. George’s School of Medicine
              </span>
            </button>
            <button
              className={`font-semibold text-[14px] md:text-[18px] flex justify-center gap-2 items-center w-1/2 px-3 py-2 text-center rounded-full ${
                activeTab === "james"
                  ? "bg-[#061a2f] shadow-[inset_0_0_18px_0_rgba(255,186,8,0.24)] text-white"
                  : "text-white brightness-[0.5]"
              }`}
              onClick={() => setActiveTab("james")}
            >
              <span className="text-left leading-[1.2]">
                Saint James School of Medicine
              </span>
            </button>
          </div>

          {/* Embla Carousel */}
          <div className="embla overflow-hidden w-full" ref={emblaRef}>
            <div className="embla__container flex gap-3">
              {[
                ...(activeTab === "george" ? big4Data : jamesData),
                ...(activeTab === "george" ? big4Data : jamesData),
              ].map((data, i) => (
                <div
                  key={`mobile-slide-${i}`}
                  className="embla__slide flex-[0_0_48%] min-w-0"
                >
                  <div className="flex justify-center items-start px-0">
                    <div
                      className="w-[170px] h-[284px] mx-auto relative p-4"
                      style={{
                        borderRadius: "11.52px",
                        border: "0.54px solid #FFF",
                        background: "#0C1F33",
                        boxShadow: "0px 0px 10.08px 0px rgba(4, 84, 175, 0.16)",
                      }}
                    >
                      <Image
                        src={data?.img}
                        alt="Student"
                        className="mx-auto rounded-full"
                        width={40}
                        height={40}
                      />
                      <p className="font-bold text-[16px] text-center text-white mt-2">
                        {data.name}
                      </p>
                      <div className="flex justify-center items-center gap-3 mt-2 mb-4">
                        <Image
                          src={data.compLogo}
                          alt={data.alliance}
                          className="h-[28px] bg-white p-1"
                          width={45}
                          height={11}
                        />
                        {data.linkdin && (
                          <a
                            href={data.linkdin}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Image
                              src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/lin.webp"
                              alt="LinkedIn"
                              width={22}
                              height={22}
                            />
                          </a>
                        )}
                      </div>
                      <div className="relative text-white text-[10px] text-center leading-[1.4] px-2">
                        <Image
                          src="/cpa/visit/newVisit/quate.png"
                          className="absolute left-[-12px] -top-5 w-[25px]"
                          alt="quote"
                          width={25}
                          height={25}
                        />
                        <Image
                          src="/cpa/visit/newVisit/quate.png"
                          className="absolute right-[-12px] -bottom-5 rotate-180 w-[25px]"
                          alt="quote"
                          width={25}
                          height={25}
                        />
                        {data.des}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-center w-full max-w-[280px] mt-4 px-4">
            <div onClick={scrollPrev} className="cursor-pointer">
              <Image
                src="/cpa/visit/newVisit/ar.png"
                alt="Previous"
                className="w-[44px]"
                width={24}
                height={24}
              />
            </div>
            <div onClick={scrollNext} className="cursor-pointer">
              <Image
                src="/cpa/visit/newVisit/ar.png"
                alt="Next"
                className="w-[44px] rotate-180"
                width={24}
                height={24}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorResidencyMobile;
